var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c("p", [
    _vm._v(
      "Your request has been closed. Please contact us with any questions."
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }